import { render, staticRenderFns } from "./SidebarBeforeAfter.vue?vue&type=template&id=fc0a8f3e&scoped=true"
import script from "./SidebarBeforeAfter.vue?vue&type=script&lang=js"
export * from "./SidebarBeforeAfter.vue?vue&type=script&lang=js"
import style0 from "./SidebarBeforeAfter.vue?vue&type=style&index=0&id=fc0a8f3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0a8f3e",
  null
  
)

export default component.exports